import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@material-ui/core";
import { TimePicker } from "material-ui-pickers";

const TimePickerField = ({
  input,
  label,
  inputProps,
  placeholder,
  disabled,
  className,
  meta,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <TimePicker
        clearable
        keyboard
        mask={[/\d/, /\d/, ":", /\d/, /\d/, " ", /a|p/i, "M"]}
        keyboardIcon={<Icon>access_time</Icon>}
        InputLabelProps={{
          shrink: true,
        }}
        {...inputProps}
        disabled={disabled}
        className={className}
        name={name}
        label={label}
        placeholder={placeholder}
        value={input.value ? input.value : null}
        onChange={input.onChange}
        onBlur={input.onBlur}
        error={meta.touched && meta.invalid}
        helperText={meta.touched && meta.error}
      />
    </div>
  );
};

TimePickerField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};

export default TimePickerField;
